// extracted by mini-css-extract-plugin
export default {"container":"document-list_container__pr90s"};